import { defAlias, defBaseUnit, defSimpleUnit } from '../registry';

export const areaUnits = [
  defBaseUnit('square_meter', 'meter^2'),
  defSimpleUnit('square_foot', 'square_meter', 0.09290313),
  defSimpleUnit('hectare', 'square_meter', 10000),
  defSimpleUnit('acre', 'square_meter', 4046.86),
];

defAlias('square meters', 'square_meter');
defAlias('square feet', 'square_foot');
defAlias('sqft', 'square_foot');
defAlias('square_feet', 'square_foot');
defAlias('square_meters', 'square_meter');
